import * as React from 'react';
import styled from 'styled-components';
import { areEqual } from 'react-window';

import type { WindowRendererProps } from '../WindowingRenderer';
import RowRenderer from '../RowRenderer';

const Row = styled.div`
  height: 100%;
`;

type Props = {
  index: number;
  style: Record<string, string | number>;
  data: WindowRendererProps;
};

const WindowedRowRenderer: React.FC<React.PropsWithChildren<Props>> = ({ index, style, data }) => {
  const {
    rows,
    openEvent,
    addUser,
    currentPeriodDays,
    shiftAppearanceMode,
    addEvent,
    toggleEvent,
    hasSelectedEvents,
    isEventSelected,
    isShiftLineVisible,
    shouldShowPlus,
    isBusinessClosed,
    isHolidayPay,
    laborUISchema,
    optionsFilter,
  } = data;

  const row = rows[index];
  return (
    <Row style={style}>
      <RowRenderer
        row={row}
        openEvent={openEvent}
        addUser={addUser}
        currentPeriodDays={currentPeriodDays}
        shiftAppearanceMode={shiftAppearanceMode}
        addEvent={addEvent}
        toggleEvent={toggleEvent}
        hasSelectedEvents={hasSelectedEvents}
        isEventSelected={isEventSelected}
        isShiftLineVisible={isShiftLineVisible}
        shouldShowPlus={shouldShowPlus}
        isBusinessClosed={isBusinessClosed}
        isHolidayPay={isHolidayPay}
        laborUISchema={laborUISchema}
        optionsFilter={optionsFilter}
      />
    </Row>
  );
};

export default React.memo(WindowedRowRenderer, areEqual);
